<template>
  <v-card class="weekendBack elevation-0">
    <v-card-title primary-title>
      <!-- <v-flex v-lang.streaming xs12></v-flex> -->
      <v-flex xs12>
        <br>
      </v-flex>
      <v-flex xs12>{{ $store.getters.getNextEvent.name }}</v-flex>
      <v-flex xs12>{{ $store.getters.getNextEvent.time }}</v-flex>
      <v-flex xs12>{{ $store.getters.getNextEventDateFormatted }}</v-flex>
      <v-flex xs12>{{ $store.getters.getNextEvent.instructor }}</v-flex>
      <v-flex xs12>
        <br>
      </v-flex>
      <!-- <v-flex xs12>State: {{getStreamingStateText}}</v-flex> -->
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: "NextEventCard"
};
</script>

<style scoped>
.weekendBack {
  background: linear-gradient(#303030, #252525 20%, #252525 80%, #303030);
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/live/NextEventCard.vue